module.exports = __webpack_public_path__ + "img/team2.07a937ba.png";